import Button from 'tailwind-components/Button/Button';
import CommissionRecoTableFilters from './CommissionRecoTableFilters/CommissionRecoTableFilters';
import CommissionRecoTable from './CommissionRecoTable/CommissionRecoTable';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import icons from 'constants/icons';
import style from './DashboardCommissionReco.module.scss';
import useComissionsReco from 'hooks/useComissionsReco';
import useDebounce from 'hooks/useDebounce';
import { Grid, TextField } from '@mui/material';

const SearchIcon = icons['search'];
const ArrowRight = icons['arrowRight'];

export default function DashboardCommissionReco({ setLocalLoader }) {
  // State
  const [showFilters, setShowFilters] = useState(false);
  const [filterCount, setFilterCount] = useState(1);
  const [isSearching, setIsSearching] = useState(true);

  // Refs
  const inputRef = useRef(null);

  const {
    data_for_table,
    currentPage,
    setCurrentPage,
    setCurrentPageSize,
    policies_records_count,
    formData,
    setformData,
    clearFilters,
    applyFilters,
    handleChangeSelectValue,
    setTriggerFetch
  } = useComissionsReco({
    setLocalLoader,
    setFilterCount,
    setShowFilters
  });

  const debouncedSearch = useDebounce(formData.searchTerm, 800);

  useEffect(() => {
    if (isSearching) return;
    applyFilters();
    setIsSearching(true);
  }, [debouncedSearch]);

  useEffect(() => {
    setIsSearching(false);
  }, [data_for_table]);

  useEffect(() => {
    if (inputRef.current) {
      if (!isSearching) inputRef.current.focus();
      else inputRef.current.blur();
    }
  }, [isSearching]);

  return (
    <Grid
      container
      columnSpacing={{ xs: 1 }}
      rowSpacing={{ xs: 1 }}
      marginTop={2}
      paddingTop={1}
    >
      <Grid
        item
        xs={showFilters ? 12 : 0}
        lg={showFilters ? 4 : 0}
        xl={showFilters ? 3 : 0}
        className={style.filtersContainerMain}
      >
        <CommissionRecoTableFilters
          filterCount={filterCount}
          setFilterCount={setFilterCount}
          formData={formData}
          setformData={setformData}
          clearFilters={clearFilters}
          handleChangeSelectValue={handleChangeSelectValue}
          applyFilters={applyFilters}
          showFilters={showFilters}
        />
      </Grid>
      <Grid item xs={12} lg={showFilters ? 8 : 12} xl={showFilters ? 9 : 12}>
        <div className={style.tableContainer}>
          <Grid container padding={2} rowSpacing={{ xs: 1 }}>
            <Grid item xs={12} sm={4}>
              <Button
                text={`${
                  showFilters ? 'Hide Filters' : 'Show Filters'
                } (${filterCount})`}
                size='medium'
                className={style.buttonNoWrap}
                variant='primaryDarkened'
                icon={
                  <ArrowRight
                    className={
                      showFilters
                        ? style.arrowRightTransitionActive
                        : style.arrowRightTransition
                    }
                  />
                }
                onClick={() => setShowFilters(!showFilters)}
              />
            </Grid>
            <Grid item xs={12} sm={8} display='flex'>
              <TextField
                inputRef={inputRef}
                disabled={isSearching}
                fullWidth
                size='small'
                id='outlined-search'
                label='Search by client name, policy number, phone, or email'
                placeholder='Enter client name, policy number, phone, or email...'
                value={formData.searchTerm}
                onChange={e => {
                  if (!isSearching) {
                    setformData({
                      ...formData,
                      searchTerm: e.target.value
                    });
                  }
                }}
                type='search'
                InputProps={{
                  sx: { borderTopRightRadius: 0, borderBottomRightRadius: 0 }
                }}
              />
              <Button
                text='Search'
                variant='primary'
                size='medium'
                className={style.searchButton}
                onClick={() => applyFilters()}
                icon={<SearchIcon />}
              />
            </Grid>
          </Grid>
          <CommissionRecoTable
            data_for_table={data_for_table}
            policies_records_count={policies_records_count}
            setCurrentPageSize={setCurrentPageSize}
            setCurrentPage={setCurrentPage}
            currentPage={currentPage}
            formData={formData}
            setTriggerFetch={setTriggerFetch}
            handleChangeSelectValue={handleChangeSelectValue}
            applyFilters={applyFilters}
          />
        </div>
      </Grid>
    </Grid>
  );
}

DashboardCommissionReco.propTypes = {
  setLocalLoader: PropTypes.func
};
